import React from 'react';

const AddRow = ({ ...attrs }) => (
  <svg viewBox="0 0 25 25" {...attrs}>
    <path d="m18.074 7.8218v1.5q0 0.312-0.219 0.531t-0.531 0.219h-3.25v3.25q0 0.312-0.219 0.531t-0.531 0.219h-1.5q-0.312 0-0.531-0.219t-0.219-0.531v-3.25h-3.25q-0.312 0-0.531-0.219t-0.219-0.531v-1.5q0-0.312 0.219-0.531t0.531-0.219h3.25v-3.25q0-0.312 0.219-0.531t0.531-0.219h1.5q0.312 0 0.531 0.219t0.219 0.531v3.25h3.25q0.312 0 0.531 0.219t0.219 0.531z" />
    <path d="m2.0996 16.474a0.88112 0.90025 0 0 0 -0.88144 0.8977v4.5774a0.88112 0.90025 0 0 0 0.88144 0.90057h20.801a0.88112 0.90025 0 0 0 0.88144 -0.90057v-4.5774a0.88112 0.90025 0 0 0 -0.88144 -0.8977h-20.801zm0.88144 1.7983h19.038v2.7763h-19.038v-2.7763z" />
  </svg>
);

export default AddRow;
